<template>
  <section class="cabinet">
    <div class="_bg-light">
      <div class="container _py-16 _py-md-12 _px-md-4 _py-sm-8">
        <h1 class="_tc-dark _fs-48 _fs-sm-32 _lh-38 _lh-64 _fw-700">
          {{ $t("cabinet.title") }}
        </h1>
      </div>
    </div>
    <div class="container _px-md-4 _py-16 _py-sm-12">
      <div class="cabinet__body">
        <div class="cabinet__userdata">
          <div class="userdata__avatar-block _mb-8">
            <div class="userdata__avatar">
              <svg
                v-if="!user.photo"
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M43.3337 45.5V41.1667C43.3337 38.8681 42.4206 36.6637 40.7953 35.0384C39.1699 33.4131 36.9655 32.5 34.667 32.5H17.3337C15.0351 32.5 12.8307 33.4131 11.2054 35.0384C9.58008 36.6637 8.66699 38.8681 8.66699 41.1667V45.5"
                  stroke="#B2B4B2"
                  stroke-width="4.33333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M25.9997 23.8333C30.7861 23.8333 34.6663 19.9531 34.6663 15.1667C34.6663 10.3802 30.7861 6.5 25.9997 6.5C21.2132 6.5 17.333 10.3802 17.333 15.1667C17.333 19.9531 21.2132 23.8333 25.9997 23.8333Z"
                  stroke="#B2B4B2"
                  stroke-width="4.33333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <img v-else :src="'/' + user.photo" />
            </div>
            <AppBtn
              @click.native="cropImage"
              class="_mt-4 _mx-sm-auto"
              :btnClass="'btn_underline'"
            >
              <span class="d-flex align-center"
                ><svg
                  class="_mr-2"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                    stroke="#629727"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span class="_fs-16"> {{ $t("cabinet.load_photo") }}</span>
              </span>
            </AppBtn>
          </div>
          <h2 class="_fs-32 _lh-38 _tc-dark _mb-4 _mb-sm-6 _fs-sm-24 _fw-700">
            {{ $t("cabinet.caption") }}
          </h2>
          <div class="d-md-flex _mb-8 d-block">
            <div class="_mr-auto w-100 _mr-md-16">
              <div class="_fs-16 _lh-24 _tc-dark-grey _mb-2">
                {{ $t("cabinet.info") }}
              </div>
              <div class="_fs-20 _lh-26 _tc-dark _mb-1">Herbalife-ID</div>
              <div class="_fs-20 _lh-26 _tc-dark-grey">{{ user.username }}</div>
            </div>
            <div class="w-100 _mt-sm-6">
              <div class="_fs-16 _lh-24 _tc-dark-grey _mb-2">
                {{ $t("cabinet.complete_caption") }}
              </div>
              <div class="progress__item d-flex mb-8">
                <Progress :value="profileFilled" :total="100" class="_mr-4">
                  <template v-slot:progress="props">
                    <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                      props.progress.value
                    }}</span>
                    <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                      /{{ props.progress.total }}</span
                    >
                  </template>
                </Progress>
                <div class="progress__text d-flex">
                  <div
                    class="progress__title _fs-sm-16 _fs-20 _lh-26 _tc-dark _my-auto"
                    v-html="$t('cabinet.complete_text')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!user.email"
            class="cabinet__warning _mb-4 _pa-4 _bg-light _br--1 d-flex align-start"
          >
            <svg
              class="_mr-2"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="10" cy="10" r="9" stroke="#C7C9C7" stroke-width="2" />
              <path
                d="M8.99929 15V7.36364H10.4858V15H8.99929ZM9.75 6.18537C9.49148 6.18537 9.26941 6.09919 9.08381 5.92685C8.90152 5.75118 8.81037 5.54238 8.81037 5.30043C8.81037 5.05516 8.90152 4.84635 9.08381 4.67401C9.26941 4.49834 9.49148 4.41051 9.75 4.41051C10.0085 4.41051 10.2289 4.49834 10.4112 4.67401C10.5968 4.84635 10.6896 5.05516 10.6896 5.30043C10.6896 5.54238 10.5968 5.75118 10.4112 5.92685C10.2289 6.09919 10.0085 6.18537 9.75 6.18537Z"
                fill="#B2B4B2"
              />
            </svg>
            <span class="_fs-14 _lh-20 _tc-dark-grey _my-auto">{{
              $t("cabinet.need_email")
            }}</span>
          </div>
          <v-input
            :class="{ '_mb-10': !name.state }"
            class="_mb-4"
            v-model="name.value"
            :state="name.state ? null : false"
            label-style="label-border"
            :label="$t('fields_labels.name') + '*'"
            :state-invalid-text="name.error"
            @change="validate(['name'])"
            @blur="validate(['name'])"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>
          <v-input
            :class="{ '_mb-10': !secondName.state }"
            class="_mb-4"
            v-model="secondName.value"
            :state="secondName.state ? null : false"
            label-style="label-border"
            :label="$t('fields_labels.surname')"
            :state-invalid-text="secondName.error"
            @change="validate(['secondName'])"
            @blur="validate(['secondName'])"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>
          <v-input
            :class="{ '_mb-10': !lastName.state }"
            class="_mb-4"
            v-model="lastName.value"
            :state="lastName.state ? null : false"
            label-style="label-border"
            :label="$t('fields_labels.lastname')"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>
          <div class="d-md-flex d-block justify-start align-start">
            <v-input
              :class="{ '_mb-10': !email.state }"
              class="_mb-4 _mr-4 _mr-sm-0 w-100"
              v-model="email.value"
              :readonly="!!user.email"
              :state="email.state ? null : false"
              label-style="label-border"
              label="Email*"
              :state-invalid-text="email.error"
              @change="validate(['email'])"
              @blur="validate(['email'])"
            >
              <template v-slot:clear>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </v-input>
            <!-- v-mask="'+7 (###) ### - ## - ##'" -->
            <div class="d-flex _ml-4 _ml-sm-0 _mb-4">
              <vue-country-code
                @onSelect="onSelectCountry"
                :enabledCountryCode="true"
                :disabledFetchingCountry="true"
                :defaultCountry="
                  user.ds_proc_country || countriesAssociation[user.language]
                "
                :onlyCountries="[
                  'AM',
                  'AT',
                  'AZ',
                  'BY',
                  'BE',
                  'BG',
                  'HR',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GE',
                  'DE',
                  'GR',
                  'HU',
                  'IL',
                  'KZ',
                  'KG',
                  'LV',
                  'LT',
                  'MD',
                  'MN',
                  'NL',
                  'PL',
                  'PT',
                  'RO',
                  'RU',
                  'RS',
                  'ES',
                  'SE',
                  'TJ',
                  'TR',
                  'GB',
                  'US',
                  'UZ',
                ]"
              >
              </vue-country-code>
              <v-input
                :masked="false"
                v-mask="maskString"
                :class="{ '_mb-10': !phone.state }"
                class="w-100"
                v-model="phone.value"
                :state="phone.state ? null : false"
                :state-invalid-text="phone.error"
                label-style="label-border"
                :label="$t('fields_labels.phone')"
                @change="validate(['phone'])"
                @blur="validate(['phone'])"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
            </div>
          </div>
          <div class="d-md-flex d-block justify-start align-start">
            <v-input
              :class="{ '_mb-10': !country.state }"
              class="_mb-4 _mr-4 _mr-sm-0 w-100"
              v-model="country.value"
              :state="country.state ? null : false"
              label-style="label-border"
              :label="$t('fields_labels.country')"
            >
              <template v-slot:clear>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </v-input>
            <v-input
              :class="{ '_mb-10': !city.state }"
              class="_mb-4 _ml-4 _ml-sm-0 w-100"
              v-model="city.value"
              :state="city.state ? null : false"
              label-style="label-border"
              :label="$t('fields_labels.city')"
            >
              <template v-slot:clear>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </v-input>
          </div>
          <div
            class="d-md-flex d-block justify-start align-start relative"
            @click="calendar = true"
          >
            <v-input
              v-mask="'##.##.####'"
              :class="{ '_mb-10': !birthday.state }"
              class="_mb-4 _mr-4 _mr-sm-0 w-100"
              v-model="birthday.value"
              readonly="true"
              :state="birthday.state ? null : false"
              label-style="label-border"
              :label="$t('fields_labels.birthday')"
            >
              <template v-slot:clear>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </v-input>
            <Calendar
              v-if="calendar"
              @dayClick="dayClick"
              :currentDate="this.user.birthday"
              @closeCalendar="closeCalendar"
            />
            <div class="_ml-4 -ml-sm-0 w-100"></div>
          </div>
          <div class="_fs-16 _lh-24 _tc-grey-light _mb-8">
            {{ $t("cabinet.required") }}
          </div>
          <AppBtn @click.native="saveData" class="_mb-6">
            <span class="_fs-16 _py-3 _px-25">{{ $t("cabinet.save") }}</span>
          </AppBtn>

          <div class="_fs-16 _lh-24 _tc-dark-grey _mb-4 _mt-4">
            {{ $t("cabinet.changePass") }}
          </div>
          <!-- <div class="_fs-16 _fw-500 _lh-24 _tc-dark-grey _mb-4">
            Требования к паролю
          </div>
          <div class="_fs-16 _lh-24 _tc-grey-light _mb-8">
            - Только латинские буквы <br />
            - Минимум 8 символов <br />
            - Минимум одна цифра <br />
          </div> -->
          <v-input
            :class="{ '_mb-8': !password.state }"
            class="_mb-6"
            v-model="password.value"
            :state="password.state ? null : false"
            :type="password.type"
            label-style="label-border"
            :label="$t('fields_labels.password')"
            :state-invalid-text="password.error"
            @blur="checkEqualPasswords"
          >
            <template v-slot:icon-append>
              <div @click="showPass">
                <svg
                  v-if="password.type === 'text'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1152_1106)">
                    <path
                      d="M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94ZM9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.24Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1152_1106">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </template>
          </v-input>

          <v-input
            :class="{ '_mb-8': !password_repeat.state }"
            class="_mb-6"
            v-model="password_repeat.value"
            :state="password_repeat.state ? null : false"
            :type="password.type"
            label-style="label-border"
            :label="$t('fields_labels.password_repeat')"
            :state-invalid-text="password_repeat.error"
            @blur="checkEqualPasswords"
          >
            <template v-slot:icon-append>
              <div @click="showPass">
                <svg
                  v-if="password.type === 'text'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1152_1106)">
                    <path
                      d="M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94ZM9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.24Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1152_1106">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </template>
          </v-input>

          <AppBtn @click.native="setPass">
            <span class="_fs-16 _py-3 _px-25">
              {{ $t("cabinet.changePassBtn") }}</span
            >
          </AppBtn>
        </div>
        <div class="cabinet__pages _mt-md-8">
          <h2 class="_fs-32 _fs-sm-24 _lh-38 _tc-dark _mb-4 _fw-700">
            {{ $t("cabinet.additional") }}
          </h2>
          <div class="cabinet__card _mb-6 _br--2 _bg-light _pl-6 _px-sm-6">
            <div class="d-flex align-center">
              <div class="_py-8 card__text">
                <div class="_fs-20 _lh-24 _tc-dark _mb-2 _fw-700">
                  {{ $t("cabinet.favorites.title") }}
                </div>
                <div class="_fs-16 _lh-24 _tc-dark-grey _mb-2">
                  {{ $t("cabinet.favorites.description") }}
                </div>
                <AppBtn
                  @click.native="favoritesClick()"
                  class="_mt-sm-auto w-100 w-md-auto"
                >
                  <div class="_tc-white _py-3 _px-4">
                    <span class="_fs-16">{{
                      $t("interface.video.watch")
                    }}</span>
                  </div>
                </AppBtn>
              </div>
              <img
                class="_ml-16 _pt-5"
                :src="require('@/assets/img/cabinet/card-1.png')"
              />
            </div>
          </div>
          <div class="cabinet__card _br--2 _bg-light _pl-6">
            <div class="d-flex align-center">
              <div class="_py-8 card__text">
                <div class="_fs-20 _lh-24 _tc-dark _mb-2 _fw-700">
                  {{ $t("cabinet.statistic.title") }}
                </div>
                <div class="_fs-16 _lh-24 _tc-dark-grey _mb-2">
                  {{ $t("cabinet.statistic.description") }}
                </div>
                <AppBtn
                  @click.native="statisticClick()"
                  class="_mt-sm-auto w-100 w-md-auto"
                >
                  <div class="_tc-white _py-3 _px-4">
                    <span class="_fs-16">{{
                      $t("interface.video.watch")
                    }}</span>
                  </div>
                </AppBtn>
              </div>
              <img
                class="_ml-16"
                :src="require('@/assets/img/cabinet/card-2.png')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Avatar ref="cropper" @fetchFile="sendUserPhoto" />
    <Modal v-if="confirmEmail" @close="modalToggle('confirmEmail', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-32 _lh-38 _fw-700 _tc-dark _mb-4"
          >
            {{ $t("modals.confirmEmail.title") }}
          </div>
          <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
            {{ $t("modals.confirmEmail.description") }}
            <span class="_tc-green-second">{{ email.value }}</span>
          </div>

          <v-input
            :class="{ '_mb-10': !emailCode.state }"
            class="_mb-4 _mr-4 _mr-sm-0 w-100"
            v-model="emailCode.value"
            :state="emailCode.state ? null : false"
            label-style="label-border"
            :label="$t('fields_labels.code')"
            :state-invalid-text="emailCode.error"
            @change="validate(['email'])"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>

          <div
            class="d-flex justify-start align-center _mt-8 direction-column-reverse direction-lg-row"
          >
            <AppBtn
              class="_mr-auto w-100 w-md-auto"
              @click.native="emailConfirm()"
            >
              <span class="_fs-16 _lh-24 _py-3 _py-sm-3 _px-4 _px-xs-0">
                {{ $t("interface.confirm") }}
              </span>
            </AppBtn>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import { bus } from "@/main";
import AppBtn from "../../components/UI/buttons/AppBtn.vue";
import Progress from "../../components/UI/intensives/Progress.vue";
import validate from "@/mixins/validate";
import { mapActions, mapGetters } from "vuex";
import Avatar from "../../components/UI/cabinet/Avatar.vue";
import Calendar from "../../components/UI/cabinet/calendar/Calendar.vue";
import Modal from "@/components/UI/Modal";
export default {
  components: { AppBtn, Progress, Avatar, Calendar, Modal },
  name: "Cabinet",
  mixins: [validate],
  data: () => ({
    countryCode: null,
    confirmEmail: false,
    calendar: false,
    name: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    secondName: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    lastName: {
      value: "",
      state: true,
      error: "",
    },
    email: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "isCorrectEmail"],
    },
    emailCode: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    phone: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "isCorrectPhone"],
    },
    password: {
      value: "",
      type: "password",
      state: true,
      error: "",
    },
    password_repeat: {
      value: "",
      state: true,
      error: "",
    },
    country: {
      value: "",
      state: true,
      error: "",
    },
    city: {
      value: "",
      state: true,
      error: "",
    },
    birthday: {
      value: "",
      state: true,
      error: "",
    },
  }),
  computed: {
    ...mapGetters(["Rules", "user"]),
    maskString() {
      return `(###) ### - ## - ##`;
    },
    countriesAssociation() {
      return {
        ru: "RU",
        kk: "KZ",
        be: "BY",
        mn: "MN",
        en: "US",
        ky: "KG",
        uz: "UZ",
        ka: "GE",
        et: "EE",
        lt: "LT",
        lv: "LV",
        az: "AZ",
        hy: "AM",
      };
    },
    profileFilled() {
      const fields = [
        "first_name",
        "last_name",
        "email",
        "ds_mobile",
        "ds_mailing_city",
        "ds_mailing_country",
        "birthday",
        "photo",
      ];
      let count = 0;
      for (let field of fields) {
        if (this.user[field]) {
          count++;
        }
      }
      return Math.round((count / fields.length) * 100);
    },
    userInfo() {
      return {
        first_name: this.name.value,
        last_name: this.secondName.value,
        middle_name: this.lastName.value,
        ds_mobile: (this.countryCode.dialCode + this.phone.value).replace(
          /\D/g,
          ""
        ),
        ds_mailing_country: this.country.value,
        ds_mailing_city: this.city.value,
        birthday: this.birthday.value,
        ds_proc_country: this.countryCode.iso2,
      };
    },
  },
  methods: {
    ...mapActions([
      "fetchChangeUserData",
      "fetchChangeUserPhoto",
      "sendEmailConfirm",
      "sendEmailConfirmCode",
      "changePassword",
      "fetchAlerts",
    ]),
    onSelectCountry({ iso2, dialCode }) {
      this.countryCode = { iso2: iso2, dialCode: dialCode };
    },
    favoritesClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "lk_goto_favorite",
        });
      }
      this.$router.push(this.helpers.buildRoute({ name: "Favorites" }));
    },
    statisticClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "lk_goto_statistic",
        });
      }
      this.$router.push(this.helpers.buildRoute({ name: "Statistics" }));
    },
    cropImage() {
      this.$refs.cropper.upload();
      if (this.$gtm) {
        this.$gtm.push({
          event: "lk_personal_photo",
        });
      }
    },
    closeCalendar() {
      setTimeout(() => {
        this.calendar = false;
      }, 300);
    },
    async fillUserData() {
      this.$set(this.name, "value", this.user.first_name);
      this.$set(this.secondName, "value", this.user.last_name);
      if (this.user.email) {
        this.$set(this.email, "value", this.user.email);
      }

      this.$set(
        this.phone,
        "value",
        this.user.ds_mobile.substring(this.user.ds_mobile.length - 10)
      );
      if (this.user.birthday) {
        this.$set(
          this.birthday,
          "value",
          this.user.birthday.split("-").reverse().join(".")
        );
      }

      this.$set(this.country, "value", this.user.ds_mailing_country || "");
      this.$set(this.city, "value", this.user.ds_mailing_city || "");
    },
    dayClick(day) {
      this.$set(
        this.birthday,
        "value",
        `${day.date.getDate().toString().padStart(2, 0)}.${(
          day.date.getMonth() + 1
        )
          .toString()
          .padStart(2, 0)}.${day.date.getFullYear()}`
      );
    },
    async emailConfirm() {
      const emailConfirmed = await this.sendEmailConfirm({
        id: this.user.id,
        email: this.email.value,
        pin: this.emailCode.value,
      });
      if (emailConfirmed) {
        this.modalToggle("confirmEmail", false);
      } else {
        this.$set(
          this.emailCode,
          "error",
          this.$t("interface.errors.wrongPin")
        );
        this.$set(this.emailCode, "state", false);
      }
    },
    async saveData() {
      if (this.validate(["email", "name", "secondName"])) {
        if (this.email.value && !this.user.email) {
          const send = await this.sendEmailConfirmCode(this.email.value);
          if (send) {
            this.modalToggle("confirmEmail", true);
          }
        }
        let res = await this.fetchChangeUserData(this.userInfo);
        if (res) {
          this.fetchAlerts({
            alerts: this.$t(`interface.saved`),
            type: "notify",
          });
        }
      }
      if (this.$gtm) {
        this.$gtm.push({
          event: "lk_personal_data_save",
        });
      }
    },
    async sendUserPhoto(data) {
      if (data) {
        const formData = new FormData();
        formData.append("photo", data);
        await this.fetchChangeUserPhoto(formData);
      }
    },
    modalToggle(model, state) {
      this[model] = state;
      bus.$emit("scrollLock", this.openedMenu);
    },
    showPass() {
      this.$set(
        this.password,
        "type",
        this.password.type === "text" ? "password" : "text"
      );
    },
    checkEqualPasswords() {
      let state = true;
      let result = this.Rules.notEqual(
        this.password.value,
        this.password_repeat.value,
        this.$t("interface.errors.passNotEquals")
      );
      if (typeof result === "string") {
        this.$set(this.password_repeat, "error", result);
        this.$set(this.password_repeat, "state", false);

        this.$set(this.password, "error", result);
        this.$set(this.password, "state", false);

        return;
      } else {
        this.$set(this.password_repeat, "error", "");
        this.$set(this.password_repeat, "state", true);

        this.$set(this.password, "error", "");
        this.$set(this.password, "state", true);
      }
      return state;
    },
    async setPass() {
      if (this.checkEqualPasswords()) {
        let changePass = await this.changePassword({
          password: this.password.value,
          password_repeat: this.password_repeat.value,
        });
        if (changePass === true) {
          this.fetchAlerts({
            alerts: this.$t(`interface.passChanged`),
            type: "notify",
          });
        } else {
          if (this.$te(`interface.errors.${changePass}`)) {
            this.$set(
              this.password,
              "error",
              this.$t(`interface.errors.${changePass}`)
            );
            this.$set(this.password, "state", false);
            this.$set(
              this.password_repeat,
              "error",
              this.$t(`interface.errors.${changePass}`)
            );
            this.$set(this.password_repeat, "state", false);
          } else {
            this.$set(
              this.password,
              "error",
              this.$t("interface.errors.passInvalid")
            );
            this.$set(this.password, "state", false);
            this.$set(
              this.password_repeat,
              "error",
              this.$t("interface.errors.passInvalid")
            );
            this.$set(this.password_repeat, "state", false);
          }
        }
      }
    },
  },
  mounted() {
    this.fillUserData();
  },
  watch: {
    user() {
      this.fillUserData();
    },
  },
};
</script>

<style lang="scss" scoped>
.relative {
  position: relative;
}
.cabinet {
  &__body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 137px;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 1fr;
    }
  }

  &__warning {
    border: 1px solid #d1d2cd;

    svg {
      flex-shrink: 0;
    }
  }

  &__card {
    border: 1px solid #d1d2cd;
    position: relative;
    @media screen and (max-width: 743px) {
      height: 344px;

      & > div {
        height: 100%;
      }
    }
    .card__text {
      @media screen and (max-width: 743px) {
        position: relative;
        z-index: 2;
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
    img {
      width: 30%;
      height: 100%;
      object-fit: contain;
      flex-shrink: 0;

      @media screen and (max-width: 743px) {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        margin: 0 !important;
        padding: 0 !important;
        width: 100%;
        height: 70%;
      }
    }
  }
}

.userdata {
  &__avatar {
    width: 155px;
    height: 155px;
    background: #d1d2cd;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 743px) {
      width: 93px;
      height: 93px;
      margin: 0 auto;
    }

    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: 50%;
    }
  }
}
</style>
<style lang="scss">
.cabinet {
  & .vue-country-select .dropdown-list {
    z-index: 10;
  }

  & .vue-country-select {
    height: 56px;
    border-color: #d4d4d4;
  }

  & .vue-country-select .country-code {
    font-family: "Noto-Sans", sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #000;
  }

  & .vue-country-select:focus-within {
    box-shadow: none !important;
    border-color: #d4d4d4;
    outline: none;
  }
}
</style>
